import React, { useState } from 'react';
import { StyledDeleteAgent } from './DeleteAgentModal.style';
import Button from '../Button';
import agentService from '../../services/agentService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../Toast';

const DeleteAgentModal = ({ onClose, _id }) => {
  const queryClient = useQueryClient();

  const removeAgent = useMutation({
    mutationFn: async id => {
      return await agentService.deleteAgent(id);
    },
    onSuccess: response => {
      onClose();
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['get-all-agents'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <StyledDeleteAgent>
      <div className="holder">
        <strong className="title">Delete your AI Agent?</strong>
        <p>Your AI agent ARI will be permanently removed from Feeda.ai</p>
      </div>
      <div className="btn-holder">
        <Button width="140px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="200px" variant="danger" loader={removeAgent?.isPending} onClick={() => removeAgent.mutate(_id)}>
          Delete Permanently
        </Button>
      </div>
    </StyledDeleteAgent>
  );
};

export default DeleteAgentModal;
